// Builds a responsive srcset from the base image URL and the CDN's available
// widths, swapping the trailing -<width> suffix.
export function buildImageSrcSet(url: string, availableWidths?: number[]): string | undefined {
  if (!availableWidths || availableWidths.length === 0) return undefined
  return availableWidths
    .map((w) => `${url.replace(/-\d+(\.\w+)$/, `-${w}$1`)} ${w}w`)
    .join(", ")
}
